import { useLocale, useTranslations } from 'next-intl';

import Button from '@/components/button/Button';
import { ButtonStyle } from '@/components/button/ButtonStyle.enum';
import Modal, { ModalProps } from '@/components/Modal';

import { getLocaleCode, getTranslationWithFallback } from '@cineamo/ui/src/helpers/translation-fallback-helper';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type NoOnlineTicketUrlModalProps = ModalProps;

export function NoOnlineTicketUrlModal(props: NoOnlineTicketUrlModalProps) {
    const t = useTranslations();
    const locale = useLocale();
    const domainConfiguration = useDomainConfiguration();
    const emptyTicketLinkText = getTranslationWithFallback(
        domainConfiguration.websiteConfiguration?.emptyTicketLinkText || {},
        getLocaleCode(locale),
        t('program.no-online-ticketing-link.text')
    );

    return (
        <Modal
            {...props}
            onClose={null}
            title={t('program.no-online-ticketing-link.title')}>
            <div className="flex flex-col space-y-36 grow">
                <span className="whitespace-pre-wrap">{emptyTicketLinkText}</span>
                <div className="grow"></div>
                <Button
                    style={ButtonStyle.frameless_on_white_bg}
                    onClick={() => props.setModalIsOpen?.(false)}
                    className="text-[var(--on-background-color)]">
                    {t('common.ok')}
                </Button>
            </div>
        </Modal>
    );
}
